import { render, staticRenderFns } from "./step.vue?vue&type=template&id=85440a66&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"
import style0 from "./step.vue?vue&type=style&index=0&id=85440a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85440a66",
  null
  
)

export default component.exports